const constants = {
    ma: 'master_admin',
    admin: 'admin',
    sourcing: 'sourcing',
    store: 'store',
    accounts: 'accounts',
    lineManager: 'line_manager',
    focalPoint: 'focal_point',
    approver: 'approver',
    requestor: 'requestor',
    comUserArr: [],
    amtcUserArr: [],
    // apiUrl: 'http://localhost:5050',
    // apiUrl: "https://amtcapi.bigblue.in",
    apiUrl: "https://demoapi.amtcmro.com",
    // apiUrl: "https://api.amtcmro.com",
    needRequestor: false
}

constants.comUserArr = [constants.lineManager, constants.focalPoint, constants.approver, constants.requestor]
constants.amtcUserArr = [constants.ma, constants.admin, constants.sourcing, constants.store, constants.accounts]

export default constants;